module.exports = __webpack_public_path__ + "static/img/allMustLive.baa887b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameImg/allMustLive.png
// module id = z60k
// module chunks = 1